import {TweenMax , TimelineLite} from "gsap";
import inview from "jquery-inview";
// import FontAnim from "./FontAnim";

class InviewAnim{
	constructor(target){
		this.target = target;
	}
	exec(){
		$(this.target).bind("inview",function(){
			if(!$(this).hasClass("is-animated")){
				TweenMax.to(this,1,{opacity:1,onComplete:function(){
					$(this.target).addClass("is-animated");	
				}});
			}
		});
	}

	fontAnim(){
		// let fontAnim = new FontAnim(".js-title-font-anim");
		// fontAnim.exec();
	}
	homeAbout(){
		const trg = $(".js-inview-home-about-1");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1,y:0};

				tl.to(".js-inview-home-about-1" , 2, param, 0.5);
				// tl.call(function(){
					// this.fontAnim();
				// },null,null,0);
				tl.to(".js-inview-home-about-2" , 1 , param, 1.5);
				tl.to(".js-inview-home-about-3" , 1 , param, 1.5);
				tl.to(".js-inview-home-about-4" , 1 , param, 2);
			}
		});
	}
	homeItems(){
		const trg = $(".js-inview-home-items-1");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1,y:0};
				tl.to(".js-inview-home-items-1" , 1 , param, 0);
				tl.to(".js-inview-home-items-2" , 1 , param, 0.2);
				tl.to(".js-inview-home-items-3" , 1 , param, 0.4);
				tl.to(".js-inview-home-items-4" , 1 , param, 0.6);
				tl.to(".js-inview-home-items-5" , 1 , param, 0.8);
				tl.to(".js-inview-home-items-6" , 1 , param, 1.0);
				tl.to(".js-inview-home-items-7" , 1 , param, 1.2);
			}
		});
		// const trg = $(".home_items-grid-item");
		// trg.bind("inview",function(){
		// 	if(!trg.hasClass("is-animated")){
		// 		let tl = new TimelineMax({onComplete:function(){
		// 			trg.addClass("is-animated");
		// 		}});
		// 		const param = {opacity:1,y:0};
		// 		tl.staggerTo(".home_items-grid-item",1,param,0.3);
		// 	}
		// });

	}
	homeContents(){
		const trg = $(".js-inview-home-contents-list");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1,y:0};
				tl.staggerTo(".js-inview-home-contents-stagger",1,param,0.3);
			}
		});
	}

	homeNews(){
		const trg = $(".js-inview-home-news-list");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1};
				tl.staggerTo(".js-inview-home-news-stagger",1,param,0.3);
			}
		});
	}
	homeBlog(){
		const trg = $(".js-inview-home-blog-list");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1};
				tl.staggerTo(".js-inview-home-blog-stagger",1,param,0.3);
			}
		});
	}
	homeAccess(){
		const trg = $(".js-inview-home-access-list");
		trg.bind("inview",function(){
			if(!trg.hasClass("is-animated")){
				let tl = new TimelineMax({onComplete:function(){
					trg.addClass("is-animated");
				}});
				const param = {opacity:1};
				tl.staggerTo(".js-inview-home-access-stagger",1,param,0.3);
			}
		});
	}
	homeAnim(){
		this.homeAbout();
		this.homeItems();
		this.homeContents();
		this.homeNews();
		this.homeBlog();
		this.homeAccess();
		this.fontAnim();
		
	}
}
module.exports = InviewAnim;
